export default {
  props: {
    src: {
      type: String
    },
    fit: {
      type: String,
      default: 'cover'
    },
    mode: {
      type: String,
      default: 'scaleToFill' // 渲染模式：参考小程序
      // https://developers.weixin.qq.com/miniprogram/dev/component/image.html#image-mode
    }
  },

  components: {},
  data() {
    return {
      loading: true,
      imgHeight: null
    };
  },
  computed: {
    finalClasses() {
      if (this.loading) return {};
      return {
        show: true
      };
    },
    finalStyles() {
      if (this.mode === 'widthFix') {
        if (this.loading) {
          return {
            height: 'auto',
            minHeight: `120px`
          };
        }
        return {
          height: this.imgHeight,
          minHeight: 0
        };
      }
      return {};
    },
    finalImgStyles() {
      const objectFit = this.fit;
      const opacity = this.loading ? 0 : 1;
      if (this.mode === 'widthFix') {
        const height = this.loading ? null : this.imgHeight + 'px';
        return {
          objectFit,
          opacity,
          height
        };
      }
      return {
        objectFit,
        opacity
      };
    }
  },
  methods: {
    handleLoad(e) {
      this.loading = false;
      this.imgHeight = e.target.clientHeight;
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};